import { KYMW1403Model } from '../kymw1403.model';
import { PublishGoodsDataModel } from '../../kymw1400/vo/publish-goods-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 掲載商品リスト情報を取得する。
 *
 * @export
 * @class GetPublishGoodsDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPublishGoodsDataService extends PlessJsonResponderSub<any> {

  private vo: PublishGoodsDataModel = null;
  private model: KYMW1403Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishGoodsDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FormID: this.vo.formID,
        OrderCodeFrom: this.vo.orderCodeFrom,
        OrderCodeTo: this.vo.orderCodeTo,
        GuideGoodsName: this.vo.guideGoodsName,
        PCode: this.vo.pCode,
        CoopIbarakiChk: this.vo.coopIbarakiChk,
        CoopTochigiChk: this.vo.coopTochigiChk,
        CoopGunmaChk: this.vo.coopGunmaChk,
        CoopChibaChk: this.vo.coopChibaChk,
        CoopSaitamaChk: this.vo.coopSaitamaChk,
        CoopTokyoChk: this.vo.coopTokyoChk,
        CoopNaganoChk: this.vo.coopNaganoChk,
        CoopNiigataChk: this.vo.coopNiigataChk,
        CoopKurucoChk: this.vo.coopKurucoChk,
        SortItem: this.vo.sortItem,
        SortOrder: this.vo.sortOrder,
        Page: this.vo.page
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1403Model} model
   * @param {PublishGoodsDataModel} vo
   * @memberof GetPublishGoodsDataService
   */
  execute(model: KYMW1403Model, vo: PublishGoodsDataModel) {
    this.model = model;
    this.vo = vo;
    this.send('getPublishGoodsData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishGoodsDataService
   */
  success(data: any) {
    // 結果データの編集
    this.model.updateServerResponse(data);

    // 「前へ」「次へ」ボタンの非活性判定を行い、更新する
    this.model.kymw1403Component.updatePagingButton();
  }
}
